/* Middle Tennessee KDM — global behaviour. No dependencies, no loops.
   Motion rule from the brand kit: things arrive, they do not bounce. */
(function () {
  'use strict';
  var d = document, root = d.documentElement;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || d).querySelectorAll(sel)); }
  function ss(k, v) { try { if (v === undefined) return sessionStorage.getItem(k); sessionStorage.setItem(k, v); } catch (e) { return null; } }

  /* ---------- Reveal: fail-open, editor-safe ---------- */
  var io = null;
  var RSEL = '.mt-r, .mt-rw';
  function revealAll(ctx) { $$(RSEL, ctx).forEach(function (el) { el.classList.add('mt-in'); }); }
  function initReveal(ctx) {
    if (!root.classList.contains('mt-js')) return;
    if (root.classList.contains('mt-intro')) { setTimeout(function () { initReveal(ctx); }, 150); return; }
    var els = $$(RSEL, ctx).filter(function (el) { return !el.classList.contains('mt-in'); });
    if (!('IntersectionObserver' in window) || reduce) { revealAll(ctx); return; }
    var groups = new Map();
    els.forEach(function (el) {
      var p = el.parentElement, i = groups.get(p) || 0;
      el.style.setProperty('--mt-d', Math.min(i, 7) * 80 + 'ms');
      groups.set(p, i + 1);
    });
    if (!io) {
      io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting) { en.target.classList.add('mt-in'); io.unobserve(en.target); }
        });
      }, { rootMargin: '0px 0px -6% 0px', threshold: 0.08 });
    }
    els.forEach(function (el) { io.observe(el); });
  }
  setTimeout(function () { revealAll(d); $$('[data-mt-count]').forEach(function (e) { if (!e.__mt) { e.__mt = 1; e.textContent = e.getAttribute('data-mt-count'); } }); }, 5000);

  /* ---------- Announcement bar ---------- */
  function initBar(ctx) {
    $$('[data-mt-bar]', ctx).forEach(function (bar) {
      var x = bar.querySelector('[data-mt-bar-x]');
      if (!x || x.__mt) return; x.__mt = 1;
      x.addEventListener('click', function () { bar.hidden = true; ss('mt-bar-x', '1'); syncDrawerTop(); });
    });
  }

  /* ---------- Header ---------- */
  var hdr, drawer, burger;
  function syncDrawerTop() {
    if (!hdr) return;
    var r = hdr.getBoundingClientRect();
    root.style.setProperty('--mt-drawer-top', Math.max(0, r.bottom) + 'px');
  }
  function closeMegas(except) {
    $$('[data-mt-mega-btn]').forEach(function (b) {
      if (b === except) return;
      b.setAttribute('aria-expanded', 'false');
      var p = d.getElementById(b.getAttribute('aria-controls')); if (p) p.hidden = true;
    });
  }
  function setDrawer(open) {
    if (!drawer || !burger) return;
    syncDrawerTop();
    drawer.hidden = !open;
    burger.setAttribute('aria-expanded', open ? 'true' : 'false');
    burger.setAttribute('aria-label', open ? burger.dataset.close : burger.dataset.open);
    d.body.classList.toggle('mt-lock', open);
  }
  function initHeader(ctx) {
    hdr = d.querySelector('[data-mt-hdr]');
    if (!hdr || hdr.__mt) return; hdr.__mt = 1;
    drawer = d.querySelector('[data-mt-drawer]');
    burger = d.querySelector('[data-mt-burger]');
    var onScroll = function () { hdr.classList.toggle('is-scrolled', window.scrollY > 4); };
    window.addEventListener('scroll', onScroll, { passive: true }); onScroll();

    var fine = window.matchMedia('(hover: hover) and (pointer: fine)').matches, t, sw;
    $$('[data-mt-mega-btn]', hdr).forEach(function (btn) {
      var panel = d.getElementById(btn.getAttribute('aria-controls'));
      var li = btn.closest('li');
      function open() { closeMegas(btn); btn.setAttribute('aria-expanded', 'true'); if (panel) panel.hidden = false; }
      function close() { btn.setAttribute('aria-expanded', 'false'); if (panel) panel.hidden = true; }
      btn.addEventListener('click', function (e) {
        var isOpen = btn.getAttribute('aria-expanded') === 'true';
        /* Hover already opened it, so a mouse click keeps it open; keyboard (detail 0) and touch still toggle. */
        if (isOpen && fine && e.detail > 0) { clearTimeout(t); clearTimeout(sw); return; }
        clearTimeout(sw); isOpen ? close() : open();
      });
      if (fine) {
        /* The panel sits outside the <li>, so hovering the item OR its panel keeps it
           open, and one shared timer closes everything 350ms after the cursor leaves
           both. When another panel is already open, switching waits 220ms so a
           diagonal move across the next item on the way down doesn't swap menus. */
        var leave = function () { clearTimeout(t); clearTimeout(sw); t = setTimeout(function () { closeMegas(); }, 350); };
        li.addEventListener('mouseenter', function () {
          clearTimeout(t); clearTimeout(sw);
          if (btn.getAttribute('aria-expanded') === 'true') return;
          if (d.querySelector('[data-mt-mega-btn][aria-expanded="true"]')) sw = setTimeout(open, 220); else open();
        });
        li.addEventListener('mouseleave', leave);
        if (panel) {
          panel.addEventListener('mouseenter', function () { clearTimeout(t); clearTimeout(sw); });
          panel.addEventListener('mouseleave', leave);
        }
      }
    });
    d.addEventListener('click', function (e) { if (!e.target.closest('[data-mt-hdr]')) closeMegas(); });
    d.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      var openBtn = d.querySelector('[data-mt-mega-btn][aria-expanded="true"]');
      closeMegas(); if (openBtn) openBtn.focus();
      if (drawer && !drawer.hidden) { setDrawer(false); burger.focus(); }
    });
    if (burger) burger.addEventListener('click', function () { setDrawer(drawer.hidden); });
    $$('[data-mt-acc]', drawer || d).forEach(function (b) {
      b.addEventListener('click', function () {
        var p = d.getElementById(b.getAttribute('aria-controls')), on = b.getAttribute('aria-expanded') !== 'true';
        b.setAttribute('aria-expanded', on ? 'true' : 'false'); if (p) p.hidden = !on;
      });
    });
    window.addEventListener('resize', function () { if (window.innerWidth >= 1024 && drawer && !drawer.hidden) setDrawer(false); syncDrawerTop(); });

    /* One red button per screen: while a red content button is on screen,
       the header Book button drops to its outline form. */
    var book = hdr.querySelector('[data-mt-book]');
    if (book && 'IntersectionObserver' in window) {
      var seen = new Set();
      var rio = new IntersectionObserver(function (es) {
        es.forEach(function (e) { e.isIntersecting ? seen.add(e.target) : seen.delete(e.target); });
        book.classList.toggle('is-quiet', seen.size > 0);
      }, { threshold: 0.01 });
      $$('.mt-btn--primary').forEach(function (b) { if (!hdr.contains(b) && !(drawer && drawer.contains(b))) rio.observe(b); });
    }
  }

  /* ---------- Reviews carousel ---------- */
  function initReviews(ctx) {
    $$('[data-mt-reviews]', ctx).forEach(function (w) {
      var tr = w.querySelector('[data-mt-track]'); if (!tr || tr.__mt) return; tr.__mt = 1;
      function step(dir) { var c = tr.firstElementChild; var dx = c ? c.getBoundingClientRect().width + 24 : tr.clientWidth; tr.scrollBy({ left: dir * dx, behavior: reduce ? 'auto' : 'smooth' }); }
      var p = w.querySelector('[data-mt-prev]'), n = w.querySelector('[data-mt-next]');
      if (p) p.addEventListener('click', function () { step(-1); });
      if (n) n.addEventListener('click', function () { step(1); });
    });
  }

  /* ---------- FAQ: one open at a time ---------- */
  function initFaq(ctx) {
    $$('[data-mt-faq]', ctx).forEach(function (f) {
      if (f.__mt) return; f.__mt = 1;
      f.addEventListener('click', function (e) {
        var b = e.target.closest('.mt-faq__btn'); if (!b) return;
        var on = b.getAttribute('aria-expanded') !== 'true';
        $$('.mt-faq__btn', f).forEach(function (o) { o.setAttribute('aria-expanded', 'false'); var a = d.getElementById(o.getAttribute('aria-controls')); if (a) a.hidden = true; });
        if (on) { b.setAttribute('aria-expanded', 'true'); var a = d.getElementById(b.getAttribute('aria-controls')); if (a) a.hidden = false; }
      });
    });
  }

  /* ---------- Stage tabs ---------- */
  function initStages(ctx) {
    $$('[data-mt-stages]', ctx).forEach(function (w) {
      if (w.__mt) return; w.__mt = 1;
      var tabs = $$('[role="tab"]', w), panels = $$('.mt-stage', w);
      w.classList.add('is-tabbed');
      function sel(i, focus) {
        tabs.forEach(function (t, j) { t.setAttribute('aria-selected', j === i ? 'true' : 'false'); t.tabIndex = j === i ? 0 : -1; });
        panels.forEach(function (p, j) { p.classList.toggle('is-on', j === i); });
        if (focus) tabs[i].focus();
      }
      tabs.forEach(function (t, i) {
        t.addEventListener('click', function () { sel(i); });
        t.addEventListener('keydown', function (e) {
          if (e.key === 'ArrowRight') sel((i + 1) % tabs.length, true);
          if (e.key === 'ArrowLeft') sel((i - 1 + tabs.length) % tabs.length, true);
        });
      });
      sel(0);
    });
  }

  /* ---------- Book form ---------- */
  function initBook(ctx) {
    $$('[data-mt-book-form]', ctx).forEach(function (wrap) {
      if (wrap.__mt) return; wrap.__mt = 1;
      var form = wrap.querySelector('form') || wrap;
      if (form.tagName === 'FORM') form.noValidate = true;
      if (!form.querySelector('[data-mt-platforms]')) return;
      var data = []; try { data = JSON.parse(form.querySelector('[data-mt-platforms]').textContent); } catch (e) {}
      var model = form.querySelector('[name="contact[Model]"]'), year = form.querySelector('[data-mt-year]'), trim = form.querySelector('[name="contact[Trim]"]');
      var trimList = form.querySelector('#mt-trims');
      function fillYears() {
        var p = data.filter(function (x) { return x.name === model.value; })[0];
        var yrs = p && p.years ? p.years : [];
        var cur = year.value;
        year.innerHTML = '';
        if (!model.value) { year.disabled = true; year.appendChild(new Option(year.dataset.empty, '')); }
        else if (yrs.length) {
          year.disabled = false; year.appendChild(new Option(year.dataset.pick, ''));
          yrs.forEach(function (y) { year.appendChild(new Option(y, y)); });
          if (yrs.indexOf(cur) > -1) year.value = cur;
        } else { year.disabled = false; year.appendChild(new Option(year.dataset.pick, '')); for (var y = new Date().getFullYear() + 1; y >= 2010; y--) year.appendChild(new Option(String(y), String(y))); }
        if (trimList) { trimList.innerHTML = ''; (p && p.trims || []).forEach(function (t) { var o = d.createElement('option'); o.value = t; trimList.appendChild(o); }); }
      }
      if (model && year) { model.addEventListener('change', fillYears); fillYears(); }

      // Preselect from ?service= and ?model=
      try {
        var q = new URLSearchParams(location.search);
        var s = q.get('service');
        if (s) $$('[data-mt-svc]', form).forEach(function (c) { if (c.dataset.mtSvc === s) c.checked = true; });
        var m = q.get('model');
        if (m && model) { $$('option', model).forEach(function (o) { if (o.dataset.handle === m) model.value = o.value; }); fillYears(); }
      } catch (e) {}

      // Join multi-select services into one readable line for the email
      var svcOut = form.querySelector('[data-mt-svc-out]');
      function syncSvc() { if (svcOut) svcOut.value = $$('[data-mt-svc]:checked', form).map(function (c) { return c.value; }).join(', '); }
      $$('[data-mt-svc]', form).forEach(function (c) { c.addEventListener('change', function () { syncSvc(); clearErr('svc'); }); });
      syncSvc();

      function err(key, on) {
        var m = form.querySelector('[data-mt-err="' + key + '"]'); if (m) m.hidden = !on;
        $$('[data-mt-errfield="' + key + '"]', form).forEach(function (el) { el.classList.toggle('is-error', on); if (el.matches('input,select,textarea')) el.setAttribute('aria-invalid', on ? 'true' : 'false'); });
      }
      function clearErr(k) { err(k, false); }
      $$('input,select,textarea', form).forEach(function (el) { el.addEventListener('input', function () { var k = el.getAttribute('data-mt-errfield'); if (k) clearErr(k); }); });

      form.addEventListener('submit', function (e) {
        syncSvc();
        var bad = null;
        var email = form.querySelector('[name="contact[email]"]'), phone = form.querySelector('[name="contact[Phone]"]');
        var emailOk = email && /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.value.trim());
        err('contact', !emailOk); if (!emailOk) bad = bad || email;
        var picked = $$('[data-mt-svc]:checked', form).length > 0;
        err('svc', !picked); if (!picked) bad = bad || form.querySelector('[data-mt-svc]');
        var nm = form.querySelector('[name="contact[name]"]');
        var nmOk = nm && nm.value.trim().length > 0; err('name', !nmOk); if (!nmOk) bad = bad || nm;
        if (model) { var mOk = !!model.value; err('model', !mOk); if (!mOk) bad = bad || model; }
        if (bad) { e.preventDefault(); bad.focus(); return; }
        try { sessionStorage.setItem('mt-quote-sent', '1'); } catch (x) {}
        // Optional Klaviyo client subscription (only when the section has a public key + list id)
        var kc = wrap.dataset.klaviyoCompany, kl = wrap.dataset.klaviyoList;
        if (kc && kl && window.fetch) {
          var sms = form.querySelector('[name="contact[SMS consent]"]');
          var attrs = { email: email.value.trim() };
          if (phone && phone.value.trim() && sms && sms.checked) attrs.phone_number = phone.value.trim();
          var body = { data: { type: 'subscription', attributes: { profile: { data: { type: 'profile', attributes: attrs } } }, relationships: { list: { data: { type: 'list', id: kl } } } } };
          try { fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(kc), { method: 'POST', keepalive: true, headers: { 'Content-Type': 'application/json', revision: '2024-10-15' }, body: JSON.stringify(body) }); } catch (x) {}
        }
      });
    });
    // Conversion signal after a successful post (fires once)
    if (d.querySelector('[data-mt-book-ok]') && ss('mt-quote-sent') === '1') {
      ss('mt-quote-sent', '0');
      d.dispatchEvent(new CustomEvent('mtkdm:quote_submitted'));
      if (typeof window.gtag === 'function') window.gtag('event', 'generate_lead', { form: 'book' });
    }
  }

  /* ---------- Click-to-call / SMS signal for GA4 + Ads ---------- */
  d.addEventListener('click', function (e) {
    var a = e.target.closest('a[href^="tel:"], a[href^="sms:"]'); if (!a) return;
    var kind = a.getAttribute('href').indexOf('tel:') === 0 ? 'tel_click' : 'sms_click';
    d.dispatchEvent(new CustomEvent('mtkdm:' + kind));
    if (typeof window.gtag === 'function') window.gtag('event', kind);
  });

  /* ---------- Footer accordions (mobile) ---------- */
  function initFooter(ctx) {
    $$('[data-mt-ftr-tog]', ctx).forEach(function (b) {
      if (b.__mt) return; b.__mt = 1;
      b.addEventListener('click', function () {
        var col = b.closest('.mt-ftr__col'), on = !col.classList.contains('is-open');
        col.classList.toggle('is-open', on); b.setAttribute('aria-expanded', on ? 'true' : 'false');
      });
    });
  }

  /* ---------- Count-up numbers (data-mt-count) ---------- */
  function initCount(ctx) {
    var els = $$('[data-mt-count]', ctx).filter(function (e) { return !e.__mt; });
    if (!els.length) return;
    function run(el) {
      el.__mt = 1; var to = parseFloat(el.getAttribute('data-mt-count')) || 0, t0 = null, dur = 1500;
      if (reduce) { el.textContent = String(to); return; }
      function f(ts) { if (!t0) t0 = ts; var p = Math.min(1, (ts - t0) / dur), e = 1 - Math.pow(1 - p, 3); el.textContent = String(Math.round(to * e)); if (p < 1) requestAnimationFrame(f); }
      requestAnimationFrame(f);
    }
    if (!('IntersectionObserver' in window)) { els.forEach(run); return; }
    var cio = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) { run(e.target); cio.unobserve(e.target); } }); }, { threshold: .15 });
    els.forEach(function (e) { e.textContent = '0'; cio.observe(e); });
  }

  /* ---------- Scroll progress + gentle parallax (one rAF loop, only while scrolling) ---------- */
  var ticking = false;
  function onFrame() {
    ticking = false;
    var h = d.documentElement.scrollHeight - window.innerHeight;
    root.style.setProperty('--mt-scroll', h > 0 ? (window.scrollY / h).toFixed(4) : 0);
    if (reduce) return;
    var vh = window.innerHeight;
    $$('[data-mt-px]').forEach(function (el) {
      var r = el.parentElement.getBoundingClientRect();
      if (r.bottom < 0 || r.top > vh) return;
      var c = (r.top + r.height / 2 - vh / 2) / vh;
      el.style.setProperty('--mt-py', (c * -40).toFixed(1) + 'px');
    });
  }
  function onScroll() { if (!ticking) { ticking = true; requestAnimationFrame(onFrame); } }
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll);

  function init(ctx) { initCount(ctx); onScroll(); initFooter(ctx); initBar(ctx); initHeader(ctx); initReviews(ctx); initFaq(ctx); initStages(ctx); initBook(ctx); initReveal(ctx); syncDrawerTop(); }
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', function () { init(d); }); else init(d);

  // Theme editor: re-init and reveal immediately so nothing sticks hidden
  ['shopify:section:load', 'shopify:section:select', 'shopify:block:select'].forEach(function (ev) {
    d.addEventListener(ev, function (e) { var t = e.target || d; if (ev === 'shopify:section:load' && t.querySelector && t.querySelector('[data-mt-hdr]')) { hdr && (hdr.__mt = 0); } init(t); revealAll(t); });
  });
})();
